import React from 'react'
import styled from 'styled-components'
import { pxToRem } from '../utils'

const Wrapper = styled.div`
  background: #fff;
  border-radius: ${pxToRem('7px')};
  box-shadow: 0 ${pxToRem('5px')} ${pxToRem('30px')} 0 rgba(0, 0, 0, 0.25);
  padding: ${pxToRem('24px')};
`

const Box = props => {
  const { children, ...rest } = props;
  return (
    <Wrapper {...rest}>{children}</Wrapper>
  )
}

export default Box



// WEBPACK FOOTER //
// ./src/components/Box.js